import each from './each';
import isArrayLike from './is-array-like';
var map = function (arr, func) {
    if (!isArrayLike(arr)) {
        // @ts-ignore
        return arr;
    }
    var result = [];
    each(arr, function (value, index) {
        result.push(func(value, index));
    });
    return result;
};
export default map;
//# sourceMappingURL=map.js.map